<template>
  <div class="grid-container grid-component">
    <q-table
      row-key="__index"
      color="secondary"
      class="scroll"
      :selection="selectable"
      :selected.sync="selected"
      :data="data"
      :columns="columnOptions"
      :loading="loading"
      :filter="filter"
      :visible-columns="columnsModel.length > 0 ? columnsModel : null"
      @request="request"
      :hide-bottom="hideFooter"
      :pagination.sync="paginationOptions"
      :rows-per-page-options="rowsPerPageOptions"
    >
      <div slot="top" slot-scope="props" class="row fit" v-if="!hideHeader">
        <q-select
          multiple
          toggle
          float-label="Show Columns"
          class="q-mx-md show-column"
          v-model="columnsModel"
          v-if="columnsModel.length > 0 && !hideShowColumns"
          :display-value="columnSelectText"
          :options="visibleColumnsOptions"
        />
        <slot slot-scope="props" name="header-left">
        </slot>
        <div
          class="header-row-count absolute-center"
          v-if="props.pagination.rowsNumber && !hideCount"
        >{{props.pagination.rowsNumber}} record{{pluralWording(props.pagination.rowsNumber)}} total</div>
         <div
          class="header-row-count absolute-center"
          v-if="!props.pagination.rowsNumber && !hideCount"
        >{{data.length}} record{{pluralWording(data.length)}} found</div>
          
        <div class="pull-right">
          <q-btn
            style="margin-right:5px"
            outline
            rounded
            color="grey"
            icon="fa fa-refresh"
            ref="gridRefresh"
            align="left"
            v-if="onRequest"
            @click="request(props)"
          >
            <q-tooltip anchor="bottom middle" self="top middle" :offset="[10, 10]">Refresh Grid</q-tooltip>
          </q-btn>
          <q-btn-dropdown
            outline
            rounded
            align="left"
            color="green"
            icon="fa fa-cloud-download"
            v-if="onExport"
          >
            <!-- <q-tooltip anchor="bottom middle" self="top middle" :offset="[10, 10]">Export Grid</q-tooltip> -->
            <q-list link>
              <q-item v-close-overlay @click.native="exportGrid(props, 'page')">
                <q-item-main>
                  Export Page
                </q-item-main>
              </q-item>
              <q-item v-close-overlay @click.native="exportGrid(props, 'all')">
                <q-item-main>
                  Export All
                </q-item-main>
              </q-item>
            </q-list>
          </q-btn-dropdown>
        </div>
      </div>
      <q-tr slot="header" slot-scope="props">
        <q-th auto-width v-if="expandable || selectable && selectable != 'none'">
          <q-checkbox
            class="select-all"
            v-if="props.multipleSelect && !hideSelectAll"
            v-model="props.selected"
            indeterminate-value="some"
            @click.native="select(selected, props.index)"
          />
        </q-th>
        <q-th auto-width class="no-padding relative-position text-center" v-if="onLaunch || onDownload || onPrint">
          <q-icon name="fa fa-ellipsis-v" style="position:static !important" size="25px"></q-icon>
        </q-th>
        <q-th v-for="col in props.cols" :key="col.name" :props="props">
          <div :style="{width:col.width || null}">
            <slot name="header-item" :col="col" :label="col.label">{{ col.label }}</slot>
            <q-btn @click.stop class="filterBtn" icon="fa fa-filter" size="sm" v-if="col.filter">
              <q-popover
                anchor="bottom right"
                :offset="[-300, 0]"
                class="q-pa-md filter"
                v-if="col.type === 'date'"
              >
                <div class="row justify-between">
                  <div class="col-5">
                    <q-datetime
                      v-model="col.filter.start"
                      type="date"
                      float-label="Start Date"
                      :format="formats.date"
                      :clearable="true"
                      @clear="onFilterClear()"
                      @change="triggerRequest(col.filter.start)"
                    />
                  </div>
                  <div>
                    <q-icon class="col-2 vertical-middle q-mt-md" name="fa fa-minus" size="1.0rem"/>
                  </div>
                  <div class="col-5">
                    <q-datetime
                      v-model="col.filter.end"
                      type="date"
                      float-label="End Date"
                      :format="formats.date"
                      :clearable="true"
                      @clear="onFilterClear()"
                      @change="triggerRequest(col.filter.end)"
                    />
                  </div>
                </div>
              </q-popover>
              <q-popover
                anchor="bottom right"
                :offset="[-300, 0]"
                class="q-pa-md filter"
                v-if="col.type === 'number'"
              >
                <div class="row justify-between" v-if="col.type === 'number'">
                  <div class="col-5">
                    <q-input
                      align="left"
                      v-model="col.filter.min"
                      type="number"
                      float-label="Minimum"
                      :clearable="true"
                      @clear="onFilterClear()"
                      @keyup.enter="triggerRequest(col.filter.min)"
                    />
                  </div>
                  <div>
                    <q-icon class="col-2 vertical-middle q-mt-md" name="fa fa-minus" size="1.0rem"/>
                  </div>
                  <div class="col-5">
                    <q-input
                      align="left"
                      v-model="col.filter.max"
                      type="number"
                      float-label="Maximum"
                      :clearable="true"
                      @clear="onFilterClear()"
                      @keyup.enter="triggerRequest(col.filter.max)"
                    />
                  </div>
                </div>
              </q-popover>
              <q-popover
                anchor="bottom right"
                :offset="[-300, 0]"
                class="q-pa-md filter"
                v-if="col.type === 'string'"
              >
                <div class="row justify-between" v-if="col.type === 'string'">
                  <q-input
                    class="full-width"
                    align="left"
                    v-if="col.type === 'string'"
                    float-label="Search by"
                    :disable="!col.filterable || false"
                    :clearable="true"
                    v-model="col.filter"
                    @clear="onFilterClear()"
                    @keyup.enter="triggerRequest(col.filter)"
                  ></q-input>
                </div>
              </q-popover>
              <q-popover
                anchor="bottom right"
                :offset="[-300, 0]"
                class="q-pa-md filter"
                v-if="col.type === 'state'"
              >
                <div class="row justify-between" v-if="col.type === 'state'">
                  <q-select
                    class="full-width"
                    align="left"
                    v-if="col.type === 'state'"
                    float-label="State"
                    :options="stateOptions"
                    :disable="!col.filterable"
                    :clearable="true"
                    v-model="col.filter"
                    @clear="onFilterClear()"
                    @input="triggerRequest(col.filter)"
                  ></q-select>
                </div>
              </q-popover>
              <q-popover
                anchor="bottom right"
                :offset="[-300, 0]"
                class="q-pa-md filter"
                v-if="col.type === 'boolean'"
              >
                <div class="row justify-between" v-if="col.type === 'boolean'">
                  <q-select
                    class="full-width"
                    align="left"
                    v-if="col.type === 'boolean'"
                    float-label="True or False"
                    :options="booleanOptions"
                    :disable="!col.filterable"
                    :clearable="true"
                    v-model="col.filter"
                    @clear="onFilterClear()"
                    @input="triggerRequest(col.filter)"
                  ></q-select>
                </div>
              </q-popover>
            </q-btn>
          </div>
        </q-th>
      </q-tr>
      <template slot="body" slot-scope="props">
        <q-tr :props="props" :class="{ exception: exceptionMap[props.key] }">
          <q-td v-if="expandable || selectable && selectable != 'none'">
            <q-checkbox
              v-if="expandable"
              color="primary"
              v-model="props.row.expand"
              @click.native="typeof onExpand == 'function' ? onExpand({props: props, row:props.row,expanded:props.row.expand}): ''"
              checked-icon="expand_less"
              unchecked-icon="expand_more"
              title="Expand"
              class="q-mr-md"
            />
            <q-checkbox
              v-if="selectable"
              color="primary"
              v-model="props.selected"
              @click.native="select(selected)"
            />
          </q-td>
          <q-td
            class="row-actions"
            @click.stop
            auto-width
            v-if="onLaunch || onDownload"
            style="min-width:85px;"
          >
            <q-btn
              @click="onLaunch(props.row)"
              icon="fa fa-external-link"
              outline
              v-if="onLaunch"
              color="primary"
            >
              <q-tooltip anchor="bottom middle" self="top middle" :offset="[10, 10]">View</q-tooltip>
            </q-btn>
            <q-btn
              @click="onDownload(props.row)"
              icon="fa fa-download"
              outline
              v-if="onDownload"
              color="primary"
            >
              <q-tooltip anchor="bottom middle" self="top middle" :offset="[10, 10]">Download</q-tooltip>
            </q-btn>
            <q-btn
              @click="onRead(props.row)"
              icon="fa fa-book"
              outline
              v-if="onRead && shouldShowRead && shouldShowRead(props.row)"
              color="purple"
              style="margin-left: 0.5em;"
            >
              <q-tooltip anchor="bottom middle" self="top middle" :offset="[10, 10]">Read Document</q-tooltip>
            </q-btn>
            <q-btn
              @click="onPrint(props.row)"
              icon="fa fa-print"
              outline
              style="margin-left: 0.3em;"
              v-if="onPrint"
              color="purple"
            >
              <q-tooltip anchor="bottom middle" self="top middle" :offset="[10, 10]">Print</q-tooltip>
            </q-btn>
          </q-td>
          <q-td v-for="col in props.cols" :key="col.name" :props="props">
            <div
              :style="{width:col.width || null}"
              :class="{ 'clickable-col': col.clickable }"
              @click="col.clickable ? handleColumnClick(props.row, col) : null"
            >
              <slot
                :name="`col-item-${col.name.toLowerCase()}`"
                :col="col"
                :value="col.value"
                :index="props.key"
              >
                <div v-if="col.label !='Date Issued' && col.label !='Date of Birth'">{{ col.value }}</div>
                <div
                  v-if="col.label =='Date of Birth'"
                >{{col.value? formattedDate(new Date(col.value)):'NA'}}</div>
                <div
                  v-if="col.label =='Date Issued'"
                >{{col.value ? formattedDate(new Date(col.value)) :'NA'}}</div>
              </slot>
            </div>
          </q-td>
          <q-td v-if="onDelete !== undefined && canDelete()">
            <q-btn
              round
              outline
              color="red"
              icon="delete"
              class="delete-icon"
              @click="onDelete(props.row)"
            >
              <q-tooltip anchor="bottom middle" self="top middle" :offset="[10, 10]">Delete</q-tooltip>
            </q-btn>
          </q-td>
        </q-tr>
        <q-tr :props="props" v-if="props.row.expand" class="expandable-row">
          <q-td colspan="100%">
            <slot :name="`col-item-expand`" :props="props"></slot>
          </q-td>
        </q-tr>
      </template>
      <template slot="pagination" slot-scope="props" class="">
        <div class="text-center row flex-center q-py-sm">
          <q-pagination
            v-if="props.pagesNumber != Infinity"
            :value="props.pagination.page"
            color="primary"
            :max="props.pagesNumber"
            :ellipses="true"
            :max-pages="6"
            direction-links
            boundary-links
            @change="val=> changePage(val)"
          />
        </div>
      </template>
    </q-table>
  </div>
</template>

<script>
import { saveAs } from "file-saver/FileSaver";
import { toArrayBuffer, formatDate } from "src/utils";
import { mapMutations, mapGetters } from "vuex";
import Vue from 'vue'

export default {
  name: "Grid",
  // props: ['expandable', 'module', 'visibleColumns', 'data', 'columns','filter', 'filterable', 'refresh', 'pageable', 'loading', 'onSelect', 'pagination', 'onRequest', 'onLaunch', 'onDownload', 'onExpand', 'onExport', 'exceptionMap'],
  props: {
    id: {},
    expandable: {},
    module: {},
    visibleColumns: {},
    data: {},
    columns: {},
    hideShowColumns: {},
    rowsPerPageOptions: {
      type: Array,
      default: () => [10,20,50,100]
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    hideFooter: {
      type: Boolean,
      default: false
    },
    hideSelectAll: {
      type: Boolean,
      default: false
    },
    hideCount: {
      type: Boolean,
      default: false
    },
    filter: {},
    filterable: {},
    refresh: {},
    selectable: "",
    selected: {
      type: Array,
      default: () => []
    },
    pageable: {},
    loading: {},
    refresh: {},
    pagination: {},
    localPagination: { type: Boolean, default: () => false },
    onSelect: {},
    onRequest: {},
    onRemove: {},
    onDelete: {},
    onLaunch: {},
    onDownload: {},
    onPrint: {},
    onExpand: {},
    onExport: {},
    exceptionMap: {
      type: Array,
      default: () => []
    },
    shouldShowRead: { type: Function, default: () => (() => {})},
    onRead: {},
    onColumnClick: {
      type: Function,
      default: null
    }
  },
  components: {},
  created() {
    const vm = this
    vm.$root.$on("refreshGrid:" + vm.id, vm.onRefreshGrid)
  },
  mounted() {
    if (this.onRequest) {
      this.request({
        pagination: this.paginationOptions
      });
    }
  },
  beforeDestroy() {
    const vm = this
    vm.$root.$off("refreshGrid:" + vm.id, vm.onRefreshGrid)
  },
  data() {
    return {           
      columnsModel: Vue.util.extend([], this.visibleColumns),
      formats: this.$store.state.shared.formats,
      showFilter: true,
      filterInput: true,
      loadingDefault: false,
      noRecordsDefault: true,
      dataDefault: [],
      beforeSearchIcon: [
        {
          icon: "search"
        }
      ],
      filterableOptions: false,
      paginationOptions: {
        rowsNumber: this.pagination ? this.pagination.rowsNumber : 0,
        rowsPerPage: this.pagination ? this.pagination.rowsPerPage : 10,
        page: this.pagination ? this.pagination.page : 1,
        descending: this.pagination ? this.pagination.descending : false,
        sortBy: this.pagination ? this.pagination.sortBy : ""
      },
      booleanOptions: [
        { label: "All", value: "" },
        { label: "True", value: true },
        { label: "False", value: false }
      ]
    };
  },
  computed: {
    columnSelectText() {
      if (this.columnsModel)
        return `${this.columnsModel.length} Columns Shown`;
    },
    refreshGrid() {
      const vm = this;
      if (this.refresh) {
        this.request({ pagination: this.paginationOptions });
      }
    },
    columnOptions() {
      return this.columns.map(column => {
        if (column.filterable) {
          if (column.type === "string") {
            column.filter = "";
          } else if (column.type === "number") {
            column.filter = { min: null, max: null };
          } else if (column.type === "state") {
            column.filter = null;
          } else if (column.type === "date") {
            column.filter = { start: null, end: null };
          } else if (column.type === "datetime") {
            column.filter = { start: null };
          } else if (column.type === "boolean") {
            column.filter = null;
          }
        }
        return column;
      });
    },
    hasException(columns) {
      return _.some(columns, column => column.exception);
    },
    visibleColumnsOptions() {
      return this.columns.map(column => {
        return {
          label: column.label,
          value: column.name
        };
      });
    },
    ...mapGetters(["stateOptions"])
  },
  methods: {
    onRefreshGrid(){
      let vm = this
      let refreshComponent = vm.$refs.gridRefresh
      if (refreshComponent) {
        let el = refreshComponent.$el
        $(el).click()
      }    
    },
    changePage(val){
      this.paginationOptions.page = val
      if (this.onRequest) {
        this.request({
          pagination: this.paginationOptions
        });
      }
    },
    formattedDate(dateString) {
      var finalDateString;
      var d = new Date(dateString);
      if(d.toString() === 'Invalid Date') return 'Invalid Date'
      var mm = d.getUTCMonth() + 1;
      var dd = d.getUTCDate();
      var yy = d.getFullYear();
      if (mm < 10) {
        mm = "0" + mm;
      }
      if (dd < 10) {
        dd = "0" + dd;
      }
      finalDateString = mm + "/" + dd + "/" + yy;

      return finalDateString;
    },
    ...mapMutations(["openDetails"]),
    exportGrid({ pagination, filtering }, amt) {
      const amount = amt || 'page'
      const columns = this.columns || null;
      const exportOptions = {
        type: "Excel",
        columns: this.columnsModel || []
      };
      if (!this.onExport) return;
      const options = {
        filtering,
        columns,
        exportOptions
      }
      if (amt === 'page') {
        options.pagination = pagination
      }

      return this.onRequest(options).then(response => {
        if (response) {
          saveAs(
            new Blob([toArrayBuffer(response.content.data)], {
              type: "application/octet-stream"
            }),
            "export.xlsx"
          );
        }
      });
    },
    request({ pagination, filtering }) {
			const columns = this.columns || null;
      if (!this.onRequest) return;
      try{
        return this.onRequest({ pagination, filtering, columns }).then(
          response => {
            this.paginationOptions = pagination
            // console.log("​request -> paginationOptions", this.paginationOptions)
            let hasCount = response.payload && response.payload.count !== undefined
            if(!this.localPagination) {
              this.paginationOptions.rowsNumber = hasCount ? response.payload.count : this.data.length
            }
            // console.log("​request -> paginationOptions****after", this.paginationOptions)
          }
        )
      }
      catch(err){
        console.log(err)
        return Promise.reject()
      }
    },
    select(selected) {
      this.onSelect(selected)
    },
    checkForExceptions(columns) {
      return _.some(columns, column => column.exception);
    },
    onFilterKeyup(filter) {
      _.debounce(() => {
        this.filter = filter.toString() || "";
      }, 200);
    },
    triggerRequest(filter) {
      this.filter = filter.toString() || "";
    },
    onFilterEnter(filter) {
      this.filter = filter || "";
    },
    onFilterBlur(filter) {
      this.filter = filter || "";
    },
    onFilterClear() {
      this.filter = "";
    },
    pluralWording(count) {
      return count === 1 ? "" : "s";
    },
    canDelete() {
      if (this.module === "classes") {
        return this.$p(["ADMIN"]);
      }
      return this.$p(["MANAGER", "ADMIN"], "or");
    },
    handleColumnClick(row, col) {
      if (this.onColumnClick) {
        this.onColumnClick({
          row,
          col,
          value: col.value,
          name: col.name,
        })
      }
    }
  },
  watch: {
    "pagination.rowsNumber"() {
      this.paginationOptions.rowsNumber = this.pagination.rowsNumber;
    },
    visibleColumns(newColumns) {
      this.columnsModel = newColumns
    }
  }
};
</script>

<style lang="stylus">
@import '~variables';
.grid-component
  .filter {
    width: 300px;
  }

  .filterBtn {
    width: 40px;
  }

  .show-column {
    max-width: 400px;
  }

  .alternate-row {
    background-color: #f5f5f5;
  }

  .exception {
    background-color: lightyellow !important;
  }

  .q-table-container {
    th {
      > div {
        display: inline-block;
      }
    }

    tbody {
      tr {
        transition: all 0.2s ease-in-out;

        &:hover {
          background: rgba(77, 131, 255, 0.2) !important;
        }

        &:nth-child(odd) {
          background: #f5f5f5;
        }
      }
    }

    .label {
      font-size: 11px;
    }

    tbody {
      tr, td {
        border: none;
        border-right: 1px solid border-color;
      }
    }

    .pull-right {
      margin-left: auto;
      order: 2;
    }

    .header-row-count {
      font-size: 12px;
      text-transform: uppercase;
      font-weight: 900;
      letter-spacing: 1px;
      color: #484848;
    }
  }

  .delete-icon {
    opacity: 0;
  }

  tr {
    &:hover {
      .delete-icon {
        opacity: 1;
      }
    }
  }

  thead tr td:nth-child(1) {
    min-width: 85px;
  }
  .q-pagination .q-btn.disabled{
    opacity 0.2 !important
  }

  .clickable-col {
    cursor: pointer;

    text-decoration: underline;
    color: $primary;
  }
</style>
